<ng-template #chipContent>
  @if (config().icon) {
    <app-dynamic
      componentName="SvgIcon"
      [props]="{ name: config().icon, size: '16', color: iconColor(), gradient: iconGradient() }"
    />
  }
  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: textConfig() }"
  />
</ng-template>

@if (isOutlined()) {
  <div
    class="w-fit p-px rounded-full"
    [style.background]="
      'linear-gradient(90deg, var(--gradients-primary-start), var(--gradients-primary-middle), var(--gradients-primary-stop))'
    "
  >
    <div
      class="flex items-center gap-1 px-4 py-2 rounded-full"
      [style.background-color]="backgroundColor()"
    >
      <ng-container *ngTemplateOutlet="chipContent" />
    </div>
  </div>
} @else {
  <div
    class="w-fit flex items-center gap-1 px-4 py-2 rounded-full"
    [style.background-color]="backgroundColor()"
  >
    <ng-container *ngTemplateOutlet="chipContent" />
  </div>
}
